<template>
  <div class=" section_sectionWrapper">
    <div class="module-cha">
      <div class="title"></div>
      <div class="cha-cont">
        <div class="ani w100 h100">
          <swiper :options="silderOptions" ref="silderOptions" class="cha-swiper">
            <swiper-slide v-for="i in 5" :key="i">
              <div class="img-size">
                <div class="ani cha-img" swiper-animate-effect="bounceInLeft" swiper-animate-duration="0.5s" swiper-animate-delay="0.3s">
                  <div class="cha-bg"></div>
                  <div class="role" :class="'role' + i"><img :src="require('../../assets/img/cha/cha' + i + '.png')"
                      alt="" srcset=""></div>
                </div>
                <div class="detail-img ani" swiper-animate-effect="bounceInRight" swiper-animate-duration="0.5s" swiper-animate-delay="0.3s">
                  <img :src="require('../../assets/img/cha/cha-lr-' + i + '.png')" alt="" srcset="">
                </div>

              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
          <div class="swiper-pagination-news"></div>
          <div class="more"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'app',


  data() {
    return {
      silderOptions: {
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        allowTouchMove: false,
        noSwiping: false,
        noSwipingClass: "stop-swiping",
        initialSlide: 0,
        pagination: {
          el: ".swiper-pagination-news",
          touchRatio: 1, //解决滑动卡顿
          longSwipesRatio: 0.1,
          threshold: 10, //如果触摸距离小于该值滑块不会被拖动
          followFinger: false,
          bulletClass: "my-swiper", //需设置.my-bullet样式
          bulletActiveClass: 'my-swiper-active',
          clickable: true, // 允许点击小圆点跳转
          autoplayDisableOnInteraction: false,

          renderBullet: function (index, className) {
            switch (index) {
              case 0:
                name = "";
                break;
              case 1:
                name = "";
                break;
              case 2:
                name = "";
              case 3:
                name = "";
              default:
                name = "";
            }
            return (
              '<div class="' +
              className +
              " " +
              className +
              [index] +
              '"><i>' +
              name +
              "</i></div>"
            );
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
  

      },
    }
  },
  watch: {


  }
}
</script>
<style lang="scss" scoped>
.module-cha {
  position: relative;
  height: 100%;
  width: 100%;
  // width: 1920px;
  // height: 1080px;

  .title {
    width: 311px;
    height: 117px;
    background-size: 100% 100%;
    position: absolute;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
    background-image: url("../../assets/img/cha/title.png");
  }

  .cha-cont {
    width: 1350px;
    height: 730px;

    position: absolute;
    left: 50%;
    transform: translate(-50%, -60%);
    top: 60%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    .img-size {
      position: relative;
      display: flex;
      align-items: start;

      img {
        width: 100%;
        height: 100%;
      }

      .cha-img {
        width: 583px;
        height: 730px;
        position: relative;
        left: 86px;

        .cha-bg {
          width: 554px;
          height: 554px;
          background-size: 100% 100%;
          background-image: url("../../assets/img/cha/cha-bg.png");
        }

        .role {
          position: absolute;
          top: 0;
          width: 583px;
          height: 730px;
        }

        .role3 {
          right: -38px;
        }

        .role4 {
          left: -82px;
        }
      }

      .detail-img {
        width: 766px;
        height: 628px;
        position: relative;

      }


    }

    .swiper-button-prev:after {
      display: none;
    }

    .swiper-button-next:after {
      display: none;
    }

    .swiper-button-prev {
      background: url("../../assets/img/cha/arrow-lf.png") no-repeat top;
      background-size: 100% 100%;
      width: 30px;
      height: 35px;
      top: auto;
      bottom: 56px !important;
      left: 110px;
    }

    .swiper-button-next {
      background: url("../../assets/img/cha/arrow-lr.png") no-repeat top;
      background-size: 100% 100%;
      width: 30px;
      height: 35px;
      top: auto;
      right: 110px;
      bottom: 56px !important;
    }

    /deep/ .swiper-pagination-news {
      position: absolute;
      bottom: 0;
      right: 290px;
      display: flex;
      width: 530px;
      z-index: 1;

      .my-swiper {
        display: inline-block;
        width: 105px;
        height: 151px;
        cursor: pointer;
      }

      .my-swiper0 {
        background: url("../../assets/img/cha/tab-1-b.png") no-repeat top;
        background-size: 100% 100%;

      }

      .my-swiper0.my-swiper-active {
        background: url("../../assets/img/cha/tab-1.png") no-repeat top;
        background-size: 100% 100%;
      }

      .my-swiper1 {
        background: url("../../assets/img/cha/tab-2-b.png") no-repeat top;
        background-size: 100% 100%;
      }

      .my-swiper1.my-swiper-active {
        background: url("../../assets/img/cha/tab-2.png") no-repeat top;
        background-size: 100% 100%;
      }

      .my-swiper2 {
        background: url("../../assets/img/cha/tab-3-b.png") no-repeat top;
        background-size: 100% 100%;

      }

      .my-swiper2.my-swiper-active {
        background: url("../../assets/img/cha/tab-3.png") no-repeat top;
        background-size: 100% 100%;
      }

      .my-swiper3 {
        background: url("../../assets/img/cha/tab-4-b.png") no-repeat top;
        background-size: 100% 100%;
      }

      .my-swiper3.my-swiper-active {
        background: url("../../assets/img/cha/tab-4.png") no-repeat top;
        background-size: 100% 100%;
      }

      .my-swiper4 {
        background: url("../../assets/img/cha/tab-5-b.png") no-repeat top;
        background-size: 100% 100%;
      }

      .my-swiper4.my-swiper-active {
        background: url("../../assets/img/cha/tab-5.png") no-repeat top;
        background-size: 100% 100%;
      }

    }


    .more {

      background: url("../../assets/img/cha/tab-m.png") no-repeat top;
      background-size: 100% 100%;
      width: 105px;
      height: 151px;
      position: absolute;
      right: 180px;
      bottom: 0;
    }

  }

}

@media screen and (max-width: 1200px) {}

@media screen and (min-width: 2560px) and (max-width: 3440px) {
  .module-cha {
    .title {
      width: 249px !important;
      height: 94px !important;
    }

    .cha-cont {
      width: 1080px !important;
      height: 620px !important;
      transform: translate(-50%, -60%) !important;
      top: 60% !important;

      .cha-img {
        width: 466px !important;
        height: 584px !important;
        left: 39px !important;

        .cha-bg {
          width: 443px !important;
          height: 443px !important;
        }

        .role {
          width: 466px !important;
          height: 584px !important;
        }

        .detail-img {
          width: 612px !important;
          height: 502px !important;
        }
      }
    }

    /deep/ .swiper-pagination-news {
      right: 265px !important;
      width: 420px !important;

      .my-swiper {

        width: 84px !important;
        height: 120px !important;

      }

    }

    .more {
      width: 84px !important;
      height: 120px !important;
    }

  }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/cha.vue